import useGoToNavigation from "../../util/useGotoNavigation";
import {useUser} from "../../util/userContext/UserContext";

export default function NotFound() {
    const {goToNavigation} = useGoToNavigation();
    const {user} = useUser()

    const goToMain = () => {
        const accessToken = localStorage.getItem("mdstech_accessToken");

        accessToken
            ? ((user && user.inOutFlag === 0)
                ? goToNavigation('main/dashboard', {}, true)
                : goToNavigation('purchase/pcs/list', {}, true))
            : goToNavigation('login', {}, true)
    }

    return <div className="login_content">
        <div className="login_box d-flex align-items-center">
            <div className="d-flex flex-column w-100">
                <h1 className="text-center">404</h1>
                <div className="text-center">
                    잘못된 URL 이거나 접근 권한이 없을 수 있습니다.
                    <br/>
                    관리자에게 문의해주십시오.
                </div>
                <button className="btn btn-info btn-lg btn_login" onClick={goToMain}>메인으로 돌아가기</button>
            </div>
        </div>
    </div>
}